/**
 * 微信 JS-SDK 扫码（绑卡等场景共用）
 * 关键：iOS 签名须用「当前页去掉 # 后的 URL」，并剔除 OAuth 回跳的 code/state。
 */
import wx from 'weixin-js-sdk';

/** App.vue 首次进入时记录 entryUrl，避免 iOS 签名校验地址带 ?code= */
export function normalizeWxEntryUrl(href) {
  const base = (href || location.href).split('#')[0];
  try {
    const u = new URL(base);
    u.searchParams.delete('code');
    u.searchParams.delete('state');
    const qs = u.searchParams.toString();
    const path = u.pathname || '/';
    return qs ? `${u.origin}${path}?${qs}` : `${u.origin}${path}`;
  } catch (e) {
    return base
      .replace(/([?&])(code|state)=[^&]*(&|$)/g, (_, sep, tail) => (tail === '&' ? sep : ''))
      .replace(/[?&]$/, '');
  }
}

function getWxSignUrl() {
  // Android 用完整地址（含 hash）；iOS 用去掉 hash 且不含 OAuth 参数的地址
  return /(Android)/i.test(navigator.userAgent)
    ? location.href
    : normalizeWxEntryUrl(location.href);
}

/** 调起微信扫码 */
export function invokeWechatScan({ requestSign, onResult, onToast }) {
  if (!/micromessenger/i.test(navigator.userAgent)) {
    onToast('请在微信内打开后再使用扫码');
    return;
  }

  requestSign(getWxSignUrl())
    .then((res) => {
      if (res.code != 0 || !res.data) {
        onToast((res && res.msg) || '扫码初始化失败');
        return;
      }
      wx.config({
        debug: false,
        appId: res.data.appId,
        timestamp: res.data.timestamp,
        nonceStr: res.data.nonceStr,
        signature: res.data.signature,
        jsApiList: ['scanQRCode'],
      });
      wx.error(() => {
        onToast('扫码初始化失败，请刷新页面后重试');
      });
      wx.ready(() => {
        wx.scanQRCode({
          needResult: 1,
          scanType: ['qrCode'],
          success: (scanRes) => onResult(scanRes.resultStr),
          fail: () => onToast('无法打开扫码，请检查微信相机权限'),
          cancel: () => {},
        });
      });
    })
    .catch(() => {
      onToast('扫码服务异常，请稍后重试');
    });
}
